import script from "./NewVideos.vue?vue&type=script&setup=true&lang=js"
export * from "./NewVideos.vue?vue&type=script&setup=true&lang=js"

import "./NewVideos.vue?vue&type=style&index=0&id=46afb62a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46afb62a"]])

export default __exports__